import React from 'react';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom';
import BlogDetailSection from '../pages/BlogDetailSection';
import DetailSection from '../pages/DetailSection';
import LandingPage from '../pages/LandingPage';
import ProfileSection from '../pages/ProfileSection';
import SearchResult from '../pages/SearchResult';

const MainRouter = () => {
	return (
		<div>
			<Router>
				<Switch>
					<Route exact path={'/'}>
						<LandingPage />
					</Route>
					<Route exact path={'/detail'}>
						<DetailSection />
					</Route>
					<Route exact path={'/holidayresult'}>
						<SearchResult />
					</Route>
					<Route exact path={'/profile'}>
						<ProfileSection />
					</Route>
					<Route exact path={'/blog'}>
						<BlogDetailSection />
					</Route>
				</Switch>
			</Router>
		</div>
	);
};

export default MainRouter;
